
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h22v10.406l-.281.313L25 15.438v12.563h-6v2.719l-1.219-.25L5 27.814V3.001zm9.125 2L17 5.719v9.344l1.719 1.719.281.313v8.906h4V14.595l.281-.313L25 12.563V5H14.125zM7 5.281v20.906l10 2.094V17.937l-1.719-1.719-.281-.313V7.28z"}})])
          )
        }
      }
    